module.exports = __webpack_public_path__ + "static/media/black-radio-selected.38bc9e7d.svg";